export default __webpack_public_path__ + "static/media/settings-on-blue.fd924df1.svg";